import React, { FC, useEffect, useState } from 'react';
import { BulkEditFinancialsTableProps } from './BulkEditFinancialsTableProps';
import useTranslation from '../../hooks/useTranslation';
import {
  filterSelectedValues,
  // filterSelectedValues,
  financialCategories,
  financialFilter,
  getTableColumns,
  returnColumnGroupingModel,
} from './utils';
import Box from '@mui/material/Box';
import Pill from '@ingka/pill';
import {
  DataGridPremium,
  GridColDef,
  useGridApiRef,
} from '@mui/x-data-grid-premium';
import { Stack } from '@mui/material';
import chevronDown from '@ingka/ssr-icon/paths/chevron-down';
import chevronUp from '@ingka/ssr-icon/paths/chevron-up';
import ListBox from '@ingka/list-box';
import ListView, { ListViewItem } from '@ingka/list-view';
import SegmentedControl from '@ingka/segmented-control';
import { setVisibleColumns } from '../BulkEditTable/utils';
import skapaColours from '@ingka/variables/colours-css';
const BulkEditFinancialsTable: FC<BulkEditFinancialsTableProps> = ({
  projects,
  onChange,
  currencyRates,
}) => {
  const apiRef = useGridApiRef();
  const containerRef = React.useRef();
  const [filterStatus, setFilterStatus] = useState(financialCategories);
  const [anchorEl, setAnchorEl] = useState(false);
  const [showEur, setShowEur] = useState(0);
  const t = useTranslation();
  const handleClickOpen = (e) => {
    e.stopPropagation();
    setAnchorEl(true);
  };
  const onOptionClicked = (value) => {
    setFilterStatus(filterSelectedValues(filterStatus, value));
  };
  const handleClickOut = () => {
    setAnchorEl(false);
  };
  const exportHandler = () => {
    apiRef.current.exportDataAsExcel();
  };

  const columns = getTableColumns(t, onChange, currencyRates);

  const onToggleClick = (index) => {
    setShowEur(index);
    setVisibleColumns(apiRef, index);
  };

  useEffect(() => {
    setVisibleColumns(apiRef, 0);
  }, []);
  return (
    <>
      <Box position="relative" mt={2}>
        <Stack direction="row" justifyContent="space-between" mb={2} mr={2}>
          <Stack
            direction="row"
            spacing={2}
            mx={1}
            justifyContent="space-between"
            ref={containerRef}
          >
            <ListBox
              popupMode
              open={!!anchorEl}
              style={{ maxHeight: 'none' }}
              onMouseLeave={handleClickOut}
              containerRef={containerRef}
              trigger={
                <Pill
                  label={`Type of budget`}
                  onClick={handleClickOpen}
                  size="small"
                  trailingIcon={anchorEl ? chevronUp : chevronDown}
                />
              }
            >
              <ListView id="filter-menu" showDivider size="small">
                {financialFilter.map((item) => (
                  <ListViewItem
                    inset
                    title={item.label}
                    control={'checkbox'}
                    controlProps={{
                      checked: filterStatus.includes(item.value),
                      value: item.value,
                    }}
                    id={`filter-item-${item.value}`}
                    onChange={() => {
                      onOptionClicked(item.value);
                    }}
                  />
                ))}
              </ListView>
            </ListBox>
            <Pill
              label={`Export to Excel`}
              onClick={exportHandler}
              size={'small'}
            />
          </Stack>

          <Stack sx={{ width: '400px' }}>
            <SegmentedControl
              activeIndex={showEur}
              items={[
                {
                  label: 'Local currency',
                },
                {
                  label: 'Euro',
                },
              ]}
              onClick={(e, index) => {
                onToggleClick(index);
              }}
              size="small"
            />
          </Stack>
        </Stack>

        <Box pdata-testid="ppm-project-bulk" sx={{ height: '70vh' }}>
          <DataGridPremium
            apiRef={apiRef}
            disableColumnPinning={false}
            rowHeight={60}
            sx={{
              '.short-dt-inputs': {
                input: {
                  width: '100%',
                },
              },
              border: 0,
              '.Mui-DatagridRow-even': {
                backgroundColor: skapaColours.colourNeutral2,
              },
              '.MuiDataGrid-columnHeaderTitle': {
                color: skapaColours.colourNeutral6,
              },
              '.number-column-error .input-field__border': {
                borderColor: skapaColours.colourCommercialMessageBtiRed,
                borderWidth: '2px',
              },

              '.MuiDataGrid-columnHeader--filledGroup': {
                height: '30px !important',
                textAlign: 'center',
                fontWeight: 'bold',
                '.MuiDataGrid-columnHeaderTitleContainer': {
                  justifyContent: 'center',
                },
                '.MuiDataGrid-columnHeaderTitle': {
                  alignSelf: 'center',
                  fontWeight: 'bold',
                },
              },
              '.MuiDataGrid-columnHeader--emptyGroup': {
                height: '30px !important',
              },

              '.header-cyan': {
                backgroundColor: 'rgba(140, 221, 255, 1)',
              },
              '.header-blue': {
                backgroundColor: 'rgba(0, 150, 210, 1)',
              },
              '.words-break .MuiDataGrid-columnHeaderTitle': {
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                lineHeight: 1,
                textAlign: 'center',
                fontSize: '12px',
              },
            }}
            filterModel={{
              items: [
                {
                  field: 'budgetType',
                  operator: 'isAnyOf',
                  value: filterStatus,
                },
              ],
            }}
            disableColumnMenu
            disableRowSelectionOnClick
            classes={{
              columnHeader: 'words-break',
            }}
            columnGroupingModel={returnColumnGroupingModel()}
            initialState={{
              pinnedColumns: {
                left: [
                  'referenceId',
                  'businessUnitId',
                  'projectName',
                  'unitType',
                  'budgetType',
                  'total',
                  'landCost',
                  'propertyInvestment',
                  'retailInvestment',
                  'retailCost',
                  'total-EUR',
                  'landCost-EUR',
                  'propertyInvestment-EUR',
                  'retailInvestment-EUR',
                  'retailCost-EUR',
                ],
              },
            }}
            columns={columns as GridColDef[]}
            rows={projects}
          />
        </Box>
      </Box>
    </>
  );
};

export default BulkEditFinancialsTable;
